module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/assessment_achievements/1_1cb68fb00386393f5f214f7d0edf9de0.png";